/* eslint-disable */
import { gRecaptcha as recaptchaConfig, firebase as firebaseConfig } from '../config';

export function serialize(obj) {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
    }
  return str.join('&');
}

export function initRecaptcha() {
  grecaptcha.ready(function () {
    grecaptcha.render('recaptcha', {
      sitekey: recaptchaConfig.sitekey,
      size: 'invisible',
      badge: 'inline',
    });
  });
}

export default function checkAndSend(formAction, formInput) {

  return new Promise(resolve => {
    grecaptcha.execute(recaptchaConfig.sitekey, { action: 'feedback' }).then(token => {
      formInput['g-recaptcha-response'] = token;
      fetch(`${firebaseConfig.cloudFunctionsUrl}/${formAction}`, {
        method: 'POST',
        body: serialize(formInput),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        }
      }).then((response) => {
        resolve(response.ok);
      });
    });
  });
}
